<list-view *ngIf="listeHistorique" [liste]="listeHistorique"></list-view>